import styled from 'styled-components';
import { Input } from '../../../../../../components/Input';

export const InputText = styled(Input)`
    width: 50%;
    margin-right: 0.571rem;
`;
